import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { X, Download, ExternalLink } from 'lucide-react'

interface ImagePreviewModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  imageUrl?: string
  title?: string
}

export default function ImagePreviewModal({ 
  open, 
  onOpenChange, 
  imageUrl, 
  title = '图片预览' 
}: ImagePreviewModalProps) {
  if (!imageUrl) return null

  const handleDownload = () => {
    const link = document.createElement('a')
    link.href = imageUrl
    link.download = `certification-${Date.now()}.jpg`
    link.click()
  }

  const handleOpenInNewTab = () => {
    window.open(imageUrl, '_blank')
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-hidden">
        <DialogHeader className="flex flex-row items-center justify-between">
          <DialogTitle className="text-lg font-semibold">{title}</DialogTitle>
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={handleDownload}
              className="flex items-center gap-1"
            >
              <Download className="w-4 h-4" />
              下载
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={handleOpenInNewTab}
              className="flex items-center gap-1"
            >
              <ExternalLink className="w-4 h-4" />
              新窗口
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onOpenChange(false)}
              className="flex items-center gap-1"
            >
              <X className="w-4 h-4" />
            </Button>
          </div>
        </DialogHeader>
        <div className="flex-1 overflow-auto">
          <div className="flex items-center justify-center min-h-[400px] bg-gray-50 rounded-lg">
            <img
              src={imageUrl}
              alt={title}
              className="max-w-full max-h-full object-contain rounded-lg shadow-lg"
              onError={(e) => {
                const target = e.target as HTMLImageElement
                target.style.display = 'none'
                target.parentElement!.innerHTML = `
                  <div class="flex flex-col items-center justify-center text-gray-500">
                    <div class="text-4xl mb-2">📷</div>
                    <div class="text-sm">图片加载失败</div>
                    <div class="text-xs mt-1">请检查图片链接是否有效</div>
                  </div>
                `
              }}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
